import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { Box } from '@fiverr-private/theme';
import { Button } from '@fiverr-private/button';
import { useImpressionItem } from '@fiverr-private/impressionable';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import pathfinder from '@fiverr-private/pathfinder';
import SafeComponent from '../../shared/SafeComponent';
import { getImpressionEnrichment, sendBigQueryEvent } from '../../utils/biEvents';
import { BQ_CLICKED_CTA_BANNER, BQ_IMP_CTA_BANNER_IS_SHOWN } from '../../utils/biEvents/events/bigQueryEvents';

const Signup = () => {
    const [ref] = useImpressionItem(getImpressionEnrichment({ eventName: BQ_IMP_CTA_BANNER_IS_SHOWN }));

    const pathToJoin = pathfinder('join', undefined, { query: { source: 'hplo_get_started' } });

    const onSignUpButtonClick = async (event) => {
        event.preventDefault();

        sendBigQueryEvent({ eventName: BQ_CLICKED_CTA_BANNER });
        await triggerSignUp({
            modalOptions: {
                triggerType: 'user_trigger',
                triggerId: 'hplo_get_started',
            },
        });
    };

    return (
        <Section paddingTop={{ default: '8', md: '10' }} paddingBottom={{ default: '8', md: '10' }}>
            <Stack gap={{ default: '10', md: '16' }} direction="column" data-test-id="signup-container" ref={ref}>
                <Stack
                    gap="10"
                    direction="column"
                    alignItems="center"
                    paddingY={{ default: '10', md: '12' }}
                    paddingX={{ default: '6', md: '0' }}
                    borderRadius="2xl"
                    backgroundColor="pink_1200"
                >
                    <Typography
                        as="h2"
                        size={{ default: 'h_xxl', md: 'h_5xl' }}
                        textAlign="center"
                        fontWeight="normal"
                        color="white"
                        letterSpacing="-1.28px"
                        lineHeight={{ default: 'h_xl', md: 'h_4xl' }}
                    >
                        <I18n
                            k="logged_out_homepage.signup.title_without_exclamation"
                            templates={{
                                em: (text) => (
                                    <Box as="em" color="orange_700" fontFamily="domaine" fontStyle="normal">
                                        {text}
                                    </Box>
                                ),
                            }}
                        />
                    </Typography>
                    <Button
                        href={pathToJoin}
                        colorScheme="white"
                        className={classNames('btn-signup')}
                        onClick={onSignUpButtonClick}
                    >
                        <I18n k="logged_out_homepage.general.get_started" />
                    </Button>
                </Stack>
            </Stack>
        </Section>
    );
};

export default SafeComponent(Signup);
